<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Tag Search</v-card-title>

        <v-card-text>
        
            <b>Edit Search</b>

            <p>Select the tags you would like to search on by clicking them.  Selected tags are in <b>bold</b></p>

            <div
                style="line-height: 55px; margin-top: -15px"
            >
                <v-chip
                    v-for="(item, index) in results"
                    :key="index"
                    :color="item.color"
                    style="margin-right: 5px;"
                    v-on:click="onClickChip(item)"
                >
                    <b
                        v-if="selected_tag_ids.includes(item.rc_tag_id)"
                    >
                        {{item.label}}
                    </b>

                    <span
                        v-else
                    >
                        {{item.label}}
                    </span>

                </v-chip>
            </div>

            <v-select
                label="Search Type"
                :items="search_type_items"
                v-model="selected_filter_type"
            />

           <b>Search Preview</b>
             <m-rc-tag-display
                :value="selected_tag_ids"
                style="margin-top: -10px; margin-bottom: -10px"
                :separator="selected_filter_type"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onClickEditTags"
            >
            Edit Tags...
            </v-btn>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            {{ok_button_text}}
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            results: [],
            selected_tag_ids: [],
            selected_filter_type: 'includes-any',
            on_save: () => {},
            organization_id: null,

            search_type_items: [
                {'text' : 'Includes all selected tags (and)', 'value': 'includes-all'},
                {'text' : 'Includes any selected tag (or)', 'value': 'includes-any'},
            ],

            ok_button_text: 'Save',
        }
    },

    methods: {

        showDialog(params)
        {
            let filter = _.cloneDeep(params.filter);

            if ( filter == null )
            {
                filter = { 'type': 'includes-any', values: [] };
            }

            this.selected_tag_ids = filter.values;
            if ( this.selected_tag_ids == null ) this.selected_tag_ids = [];

            this.selected_filter_type = filter.type;
            if ( this.selected_filter_type == null ) this.selected_filter_type = 'includes-any';

            this.on_save = params.on_save == null ? () => {} : params.on_save;
            this.organization_id = params.organization_id;
            this.ok_button_text = params.ok_button_text == null ? 'Save' : params.ok_button_text;

            if ( params.applies_to == 'organization' || params.applies_to == 'organization-origin' )
                params.organization_id = null;

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/rc-tags',
            
                {
                    'organization_id': params.organization_id,
                    'applies_to': { 'type': 'contains', 'value' : params.applies_to },
                    'is_archived': params.show_archived ? null : false,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get tags');
                },
            );

            this.dialog = true;
        },

        onClickChip(item)
        {
            if ( this.selected_tag_ids.includes(item.rc_tag_id) )
            {
                this.selected_tag_ids = this.selected_tag_ids.filter(a => a !== item.rc_tag_id);
            }
            else
            {
                this.selected_tag_ids.push(item.rc_tag_id);
            }
        },

        onOk()
        {
            this.dialog = false;
            this.on_save(
                _.cloneDeep({
                    'type': this.selected_filter_type,
                    'values': this.selected_tag_ids
                })
            );
        },

        onCancel()
        {
            this.dialog = false;
        },
        
        onClickEditTags()
        {
            this.$router.push({
                'name': 'settings-organization-tags',
                'params' : {
                    'organization_id': this.organization_id
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>